










import { Vue, Component } from 'vue-property-decorator';
import ComandoVelocidad from '@/pantallas/ComandoVelocidad/ComandoVelocidad.vue';

@Component({
  components: { ComandoVelocidad },
})
export default class ComandoVelocidadPantalla extends Vue {}
